import { AffiliateLink } from "components/BuyBookButton/contants";
import compact from "lodash/compact";
import { PageSerializersBooksShow } from "types/serializers";

export function fetchIsbn13(book: PageSerializersBooksShow) {
  if (book.defaultPhysicalEdition?.isbn13?.length === 13) {
    return book.defaultPhysicalEdition.isbn13;
  }
  if (book.defaultAudioEdition?.isbn13?.length === 13) {
    return book.defaultAudioEdition.isbn13;
  }
  if (book.defaultEbookEdition?.isbn13?.length === 13) {
    return book.defaultAudioEdition.isbn13;
  }
}
export function fetchIsbn10(book: PageSerializersBooksShow) {
  if (book.defaultPhysicalEdition?.isbn10?.length === 10) {
    return book.defaultPhysicalEdition.isbn10;
  }
  if (book.defaultAudioEdition?.isbn10?.length === 10) {
    return book.defaultAudioEdition.isbn10;
  }
  if (book.defaultEbookEdition?.isbn10?.length === 10) {
    return book.defaultAudioEdition.isbn10;
  }
}

export function affiliateLinkBookshop(isbn13?: string) {
  if (!isbn13) {
    return null;
  }
  return {
    link: `https://bookshop.org/a/54943/${isbn13}`,
    title: "BookShop.org",
    subtitle: "Independent Bookstores",
  };
}
export function affiliateLinkBookshopUk(isbn13?: string) {
  if (!isbn13) {
    return null;
  }
  return {
    link: `https://uk.bookshop.org/a/13479/${isbn13}`,
    title: "BookShop.org UK",
    subtitle: "Independent Bookstores",
  };
}

export function affiliateLinkAmazon(isbn10?: string, isbn13?: string) {
  if (!isbn10 && !isbn13) {
    return null;
  }
  return {
    link: `https://www.amazon.com/dp/product/${
      isbn10 || isbn13
    }/?tag=hardcoverapp-20`,
    title: "Amazon",
    subtitle: "Corporate Behemoth",
  };
}
export function affiliateLinkAmazonUk(isbn10?: string, isbn13?: string) {
  if (!isbn10 && !isbn13) {
    return null;
  }
  return {
    link: `https://www.amazon.co.uk/gp/product/${
      isbn13 || isbn10
    }/?tag=hardcoverapp-20`,
    title: "Amazon UK",
    subtitle: "Corporate Behemoth",
  };
}

export function getAffiliatesLinks(book: PageSerializersBooksShow): AffiliateLink[] {
  try {
    const isbn13 = fetchIsbn13(book);
    const isbn10 = fetchIsbn10(book);
    return compact([
      affiliateLinkBookshop(isbn13),
      affiliateLinkBookshopUk(isbn13),
      affiliateLinkAmazon(isbn10, isbn13),
      affiliateLinkAmazonUk(isbn10, isbn13),
    ]);
  } catch {
    return [];
  }
}
